var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"loading":_vm.loading,"buttons":['cancel'],"title":`Requisições com reserva${_vm.lote ? ` (${_vm.lote})` : ''}`,"large":""}},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.requisicoes,"hide-filters":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }